import videojs from 'video.js';

window.initVideoCard = function () {
    const cards = Array.from(document.querySelectorAll('.js-card'));

    cards.forEach((card) => {
        if (card.classList.contains('video-card-initialized')) return;
        card.classList.add('video-card-initialized');

        const videoElement = card.querySelector('.js-card-video');
        if (!videoElement) return;

        const player = videojs(videoElement, {
            muted: true,
            loop: true,
            controls: false,
            playsinline: true,
        });

        card.addEventListener('mouseenter', () => {
            player.play();
            card.classList.add('is-playing');
        });

        card.addEventListener('mouseleave', () => {
            player.pause();
            player.currentTime(0);
            card.classList.remove('is-playing');
        });
    });
}
document.addEventListener('DOMContentLoaded', () => {


    initVideoCard();
});
